// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__17HaC","label":"CategoryService_label__3aBlB","location":"CategoryService_location__cRlLe"};